/**
 * App 链接适配
 * @param {string} url - App URL Schema URL
 * 
 * 例子：
 * - Detail: 
 *   enalibaba://detail?id=60594080460 -> en:    https://m.alibaba.com/product/60756045406/product.html
 *                                     -> other: https://m.chinese.alibaba.com/p-detail/product-62345827749.html
 * - FreePage
 *   enalibaba://freePage?page=detailTaPage  -> https://m.alibaba.com/stream.htm?page=detailTaPage
 */
export function appUrlAdaptive(url) {

  if (!url || !url.startsWith('enalibaba://')) {
    return url;
  }

  let newUrl = url;
  const urlObj = new URL(url);
  if (urlObj && urlObj.search) {
    const isEn = window.location.host === 'm.alibaba.com';
    const params = new URLSearchParams(urlObj.search);
    if (params) {
      if (url.startsWith('enalibaba://detail')) {
        if (params) {
          const productId = params.get('id')
          if (productId && productId.length > 0) {
            if (isEn) {
              newUrl = `/product/${productId}/product.html`;
            } else {
              newUrl = `/p-detail/product-${productId}.html`;
            }
          }
        }
      } else if (url.startsWith('enalibaba://freePage')) {
        const page = params.get('page')
        if (page && page.length > 0) {
          newUrl = `/stream.htm?page=${page}`;
        }
      }
    }
  }
  return newUrl;
}

/**
 * 判断 URL 是否为 App FreePage URL，且是浮层模式
 * @param {string} url - App URL Schema URL
 * 
 * 例子："enalibaba://freePage?page=detailTaPage&displayMode=popup"
 * 例子："https://m.alibaba.com/stream.htm?page=ProductDetailCompanyProfileLanding_new&fp-hiddenback=1&displayMode=popup"
 */
export function isFreePagePopupURL(url) {
  return url.indexOf('displayMode=popup') >= 0;
}